import { EnumAccountActions } from './account_actions';
import update from 'immutability-helper';

const initialState = {
    version: "0.0.0",
    utente: null,
    //isGestore se la listaClienti > 1,
    listaClienti: null,
    clienteSelezionato: null,
    authorizations: {},
    listaAccessi: {},
    isSSO: false,
    token: null
}

const account = (state, action) => {

    if (typeof state === 'undefined') {
        return initialState
    }

    //console.log('[Reducer account] action: ' + action.type);

    switch (action.type) {
        case EnumAccountActions.GET_VERSION:
            console.log('[Reducer account] action: ' + action.type);
            return update(state, { version: { $set: action.result } });
        case EnumAccountActions.LOGIN_SUCCESS:
            console.log('[Reducer account] action: ' + action.type);
            console.log('\t LOGIN_SUCCESS');
            console.log('\t userId ' + action.user.userId);

            return Object.assign({}, state, { utente: action.user });
        case EnumAccountActions.LOGIN_FAILED:
            console.log('[Reducer account] action: ' + action.type);
            let newState = initialState;
            newState.version = state.version;
            return Object.assign({}, state, newState);

        case EnumAccountActions.LOGOUT:
            console.log('[Reducer account] action: ' + action.type);
            return Object.assign({}, state, initialState);

        case EnumAccountActions.ACCESSI_LIST:
            console.log('[Reducer user] action: ' + action.type);
            return update(state, { $merge: { listaAccessi: action.listaAccessi } });

        case EnumAccountActions.SSO:
            let isSSO = false;
            isSSO = action.datiUtente.userId !== null && action.datiUtente.userId !== undefined;
            let token = null;
            if (isSSO) {
                token = action.datiUtente.userCookie;
            }

            return update(state, { isSSO: { $set: isSSO }, token: { $set: token } });

        default:
            return state;
    }
}

export default account;